import React, { useState, useRef } from "react";
import "./App.css";
import "./MapImages.css";
import WindowDimensions from "./WindowDimensions";
import MapPopup from "./MapPopup";

const MapImages = ({ data, imageName, mapPageCallback, popupRef, movePopup, openPopup, closePopup, animationTimer, handleClick }) => {
  const [clickedId, setClickedId] = useState(-1);
  const { width } = WindowDimensions();
  var isMobile = false;
  const img_location_prefix = `./content/pins/pin-`;
  if (width <= 768) {
    isMobile = true;
  } else {
    isMobile = false;
  }

  var pixelData;

  function highlightGroup(event, id) {
    var img = event.target;
    var canvas = document.createElement("canvas");
    canvas.width = img.width;
    canvas.height = img.height;
    canvas.getContext("2d").drawImage(img, 0, 0, img.width, img.height);

    pixelData = canvas.getContext("2d").getImageData(event.nativeEvent.offsetX, event.nativeEvent.offsetY, 1, 1).data;

    for (var i = 0; i < pixelData.length; i++) {
      if (pixelData[i] !== 0) {
        setClickedId(id);
      } else {
        setClickedId(-1);
      }
    }
  }

  return (
    <div>
      {data["images"].map((image, i) => {
        var imageLocation = img_location_prefix + image.pinColour;
        var imageHoverLocation = img_location_prefix + "hover";
        var imageId = image.name + "(" + data["journeyCategory"] + ")";
        var size = image.size;
        if (isMobile) {
          size = size * 2;
        }
        return (
          <div key={i}>
            {image.title === undefined ? null : (
              <div className="App-map-icon" onClick={closePopup} style={{ left: image.xPosition, top: image.yPosition, width: size }}>
                <img
                  className="JourneyPin"
                  id={imageId}
                  alt="Normal Map Icon"
                  onMouseMove={(event) => highlightGroup(event, i)}
                  onClick={(event) => {
                    handleClick(event, image);
                    event.stopPropagation();
                  }}
                  src={require(imageLocation + ".png").default}
                  style={{ width: size + (clickedId === i) + image.operator, cursor: clickedId === i ? "pointer" : "default" }}
                />

                <label className="pin-label" style={{ top: `${-size - 0.5}${image.operator}` }}>
                  {i + 1}
                </label>
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
};

export default MapImages;
